/**
 * Normalizes configuration data based on the specified app type
 *
 * @param rawConfig - The raw configuration object to be normalized
 * @returns A normalized Config object with standardized structure
 */

export const normalizeLibreSharingConfig = rawConfig => {
  const config = {
    ...rawConfig,
    validation: {
      identity: rawConfig.validation.identity,
      api: {
        patient: {
          firstName: {
            stringMaxLength: rawConfig.validation.libreSharingApi.patient.firstName.stringMaxLength
          },
          lastName: {
            stringMaxLength: rawConfig.validation.libreSharingApi.patient.lastName.stringMaxLength
          }
        }
      }
    }
  };
  return config;
};
export const normalizeLibreConfig = rawConfig => {
  const config = {
    adultAges: rawConfig.adultAges,
    i18n: rawConfig.i18n,
    supportedCountries: rawConfig.supportedCountries,
    countries: rawConfig.countries,
    languages: rawConfig.languages,
    libreApiUrl: rawConfig.libreApiUrl,
    libreApiCountryUrls: rawConfig.libreApiCountryUrls,
    documentsUrl: rawConfig.documentUrls.files,
    documents: rawConfig.documentPaths.files,
    validation: {
      identity: rawConfig.validation.identity,
      api: {
        patient: {
          firstName: {
            stringMaxLength: rawConfig.validation.libreApi.patient.firstName.stringMaxLength
          },
          lastName: {
            stringMaxLength: rawConfig.validation.libreApi.patient.lastName.stringMaxLength
          }
        }
      }
    }
  };
  return config;
};